import SampleReportView from "@/components/samples/SampleReportView";
import { SIMPLY_SOLAR_REPORT } from "@/data/sample-reports";

const SimplySolarSample = () => <SampleReportView report={SIMPLY_SOLAR_REPORT} />;

export default SimplySolarSample;
